import React from "react";

import {
  Box,
  Typography,
  useTheme,
  InputAdornment,
  TextField,
} from "@mui/material";
import { useFormContext } from "react-hook-form";
import { withStyles } from "tss-react/mui";

import { muiFieldError } from "@/utils/hookForm";

import { RecipeFormValues } from "./RecipeForm";

const Root = withStyles(Box, () => ({
  root: {
    flex: 1,
  },
}));

const RecipeDetailsForm: React.FC = () => {
  const theme = useTheme();
  const {
    register,
    formState: { errors },
  } = useFormContext<RecipeFormValues>();

  return (
    <Root>
      <Box>
        <Typography variant="subtitle2">Recipe Name</Typography>
        <Box margin={theme.spacing(0.5)} />
        <TextField
          {...register("name")}
          {...muiFieldError(errors.name)}
          size="small"
          fullWidth
        />
      </Box>
      <Box margin={theme.spacing(0.25)} />
      <Box>
        <Typography variant="subtitle2">Preparation Time</Typography>
        <Box margin={theme.spacing(0.5)} />
        <TextField
          {...register("preparationMinutes")}
          {...muiFieldError(errors.preparationMinutes)}
          type="number"
          size="small"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">minute(s)</InputAdornment>
            ),
          }}
          fullWidth
        />
      </Box>
      <Box margin={theme.spacing(0.25)} />
      <Box>
        <Typography variant="subtitle2">Portions per recipe</Typography>
        <Box margin={theme.spacing(0.5)} />
        <TextField
          {...register("portions")}
          {...muiFieldError(errors.portions)}
          type="number"
          size="small"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">serving(s)</InputAdornment>
            ),
          }}
          fullWidth
        />
      </Box>
      <Box margin={theme.spacing(0.25)} />
      <Box marginBottom={theme.spacing(3)}>
        <Typography variant="subtitle2">Description</Typography>
        <Box marginBottom={theme.spacing(0.5)} />
        <TextField
          {...register("description")}
          {...muiFieldError(errors.description)}
          size="small"
          rows={4}
          multiline
          fullWidth
        />
      </Box>
    </Root>
  );
};

export default RecipeDetailsForm;
